import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutResign extends PacketOut {

    constructor() {
        super(OutboundPacketType.RESIGN);
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {};
    }
}
